/* eslint-disable no-useless-escape */
import AlarmMsg from '@/utils/alarmMsg'
import { addHyphenNumber } from '@/utils/common'
import tokenStore from '@/utils/TokenManager/tokenStore';
import moment from 'moment'

const PHONE_WITH_DASH_REGEX = /^(01[016789]{1})-([\d]{3,4})-([\d]{4})$/;

export default {
  install (Vue, options) {
    // 특정 글자 수 이상은 말줄임표를 한다. blarblar...
    // 사용법 {{ 값 | textEllipse(4) }}
    Vue.filter('textEllipse', function (value, length) {
      if (value && value.length > length) {
        value = value.substr(0, length) + '...'
      }
      return value
    })

    // 금액에 콤마를 집어 넣는다. format:#,###
    // 사용법 {{ 값 | addCommma }}
    Vue.filter('addCommma', function (value) {
      if (!value) {
        return 0
      }
      value = String(value)
      return value.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')
    })

    // 날짜형식을 변환한다.
    // 사용법 {{ 값 | formatDate('YYYY년 MM월 DD일') }}
    Vue.filter('formatDate', function (value, format = 'YYYY.MM.DD') {
      if (value) {
        return moment(String(value)).format(format)
      }
    })

    // 날짜 년월일로 변환한다.
    // ex)2019-01-01 23:59:59 00:00:00 -> 2019-01-01
    Vue.filter('dateSubstr', function (value, format) {
      if (!value) return
      return value.substr(0, 10)
    })

    /**
     * Hyphen(-)이 붙은 형태의 번호로 치환
     * 사용법 : {{ 값 | changeHyphenNumber }}
     */
    Vue.filter('changeHyphenNumber', function (value) {
      if (!value) return ''
      if(!PHONE_WITH_DASH_REGEX.test(value)) return addHyphenNumber(value)
      return value
    })

    /* 로그인체크
    router: this.router(필수),
    msg: 내용,
    title: 제목
    type: confirm, alert
    btn1: confrim 사용시 왼쪽버튼
    btn2: confrim 사용시 오른쪽버튼
    //호출시 this.$globalLoginCheck() */
    Vue.prototype.$globalLoginCheck = (router, msg, title, type, btn1, btn2) => {
      msg = msg || '로그인 시 사용 가능한 기능입니다.<br/>로그인을 해주세요.'
      if (!tokenStore.get().accessToken) {
        if (type) {
          AlarmMsg.showConfirm(msg, title, btn1, btn2).then(confirm => {
            router.push({ name: 'login', params: router.history.current })
          }).catch(cancel => {
            console.log(cancel)
          })
        } else {
          AlarmMsg.showMsg(msg, title).then(confirm => {
            router.push({ name: 'login', params: router.history.current })
          })
        }
      }
    }

    /**
     * @deprecated
     * @param {*} value
     * @param {*} length
     * @returns
     */
    Vue.prototype.$textEllipse = (value, length) => {
      if (value && value.length > length) {
        value = value.substr(0, length) + '...'
      }
      return value
    }

    // value가 빈값인지 체크한다.
    // value가 빈 값이면 ture를 리턴한다.
    // 사용법 this.$isEmpty(value)
    Vue.prototype.$isEmpty = (value) => {
      // undefined 나 null인지 확인
      if (value === undefined || value === null) return true

      // string
      if (typeof value === 'string' && value.length === 0) return true

      // number
      if (typeof value === 'number' && value === 0) return true

      // array
      if (Array.isArray(value) && value.length === 0) return true

      // object
      if (typeof value === 'object' && Object.keys(value).length === 0) return true

      return false
    }

    // 이메일 형식 체크
    // value 가 이메일 형식에 맞으면 true, 맞지 않으면 false를 리턴한다.
    // 사용법 this.$validEmail(value)
    Vue.prototype.$validEmail = (value) => {
      //let regx = /^[0-9a-zA-Z][0-9a-zA-Z\_\-\.\+]+[0-9a-zA-Z]@[0-9a-zA-Z][0-9a-zA-Z\_\-]*[0-9a-zA-Z](\.[a-zA-Z]{2,6}){1,2}$/i
      let regx = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i
      if (value.match(regx) === null) {
        return false
      }
      return true
    }

    // 전화번호 형식 체크
    // value 가 전화번호 형식에 맞으면 true, 맞지 않으면 false를 리턴한다.
    // 사용법 this.$validTelNo(value)
    Vue.prototype.$validTelNo = (value) => {
      let regx = /^0([0-9]{1,2})-?([0-9*]{3,4})-?([0-9]{4})$/
      if (value.match(regx) === null) {
        return false
      }
      return true
    }

    // 날짜 형식을 변경한다.
    // 필터와 동일
    // 사용법 this.$formatDate(date, 'YYYY-MM-DD')
    Vue.prototype.$formatDate = (value, format) => {
      return moment(String(value)).format(format)
    }

    // 이미지 그레이 스케일
    Vue.prototype.$grayScale = (refImage, originalWidth, originalHeight) => {
      let width = originalWidth || refImage.width
      let height = originalHeight || refImage.height
      var myCanvas = document.createElement('canvas')
      var myCanvasContext = myCanvas.getContext('2d')
      myCanvas.width = width
      myCanvas.height = height
      myCanvasContext.drawImage(refImage, 0, 0)

      // This function cannot be called if the image is not rom the same domain.
      // You'll get security error if you do.
      var imageData = myCanvasContext.getImageData(0, 0, width, height)

      // This loop gets every pixels on the image and
      for (var y = 0; y < imageData.height; y++) {
        for (var x = 0; x < imageData.width; x++) {
          var i = (y * 4) * imageData.width + x * 4
          var avg = (imageData.data[i] + imageData.data[i + 1] + imageData.data[i + 2]) / 3
          imageData.data[i] = avg
          imageData.data[i + 1] = avg
          imageData.data[i + 2] = avg
        }
      }
      myCanvasContext.putImageData(imageData, 0, 0, 0, 0, imageData.width, imageData.height)
      return myCanvas.toDataURL()
    }

    // 파일 다운로드
    Vue.prototype.$downloadFile = (response, defualtFileName) => {
      return new Promise((resolve, reject) => {
        if (window.navigator.msSaveOrOpenBlob) {
          const blob = new Blob([response.data], { type: response.data.type })
          window.navigator.msSaveOrOpenBlob(blob, defualtFileName)
        } else {
          const blob = new Blob([response.data], { type: response.data.type })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDispsition = response.headers['content-disposition']
          let filename = defualtFileName
          if (contentDispsition) {
            const filenameMatch = contentDispsition.match(/filename=(.+)/)
            if (filenameMatch.length === 2) {
              filename = decodeURIComponent(filenameMatch[1])
            }
          }
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        }
        resolve()
      })
    }

    Vue.prototype.$convertOnlyInt = (value) => {
      if (value === undefined || value === '') return 0
      value = value.toString()
      return parseInt(value.replace(/[^0-9]/g, ''))
    }

    Vue.prototype.$alert = (...args) => {
      return AlarmMsg.showMsg(args[0], args[1], typeof args[2] === 'object' ? undefined : args[2], args[3]);
    };
    Vue.prototype.$confirm = (...args) => {

      return AlarmMsg.showSafetyConfirm(args[0], args[1], typeof args[2] === 'object' ? undefined : args[2], args[3]);
    };
  }
}
